var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0FBBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.5 19.31V25.5H30.42C29.75 25.5 28.96 25.02 28.65 24.43L27.61 22.46C27.33 21.93 26.93 21.96 26.71 22.51L24.41 28.32C24.16 28.97 23.74 28.97 23.48 28.32L22.34 25.44C22.07 24.74 21.23 24.17 20.48 24.17L14.5 24.2V19.31C14.5 15.67 16.67 13.5 20.31 13.5H28.69C32.33 13.5 34.5 15.67 34.5 19.31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 27.6897V25.4997H30.42C29.75 25.4997 28.96 25.0197 28.65 24.4297L27.61 22.4597C27.33 21.9297 26.93 21.9597 26.71 22.5097L24.41 28.3197C24.16 28.9697 23.74 28.9697 23.48 28.3197L22.34 25.4397C22.07 24.7397 21.23 24.1697 20.48 24.1697L14.5 24.1997V27.6897C14.5 31.2697 16.6 33.4297 20.13 33.4897C20.24 33.4997 20.36 33.4997 20.47 33.4997H28.47C28.62 33.4997 28.77 33.4997 28.91 33.4897C32.42 33.4097 34.5 31.2597 34.5 27.6897Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 24.2002V27.5102C14.4807 27.1902 14.4707 26.8502 14.4707 26.5002V24.2002H14.5007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflow);
export default __webpack_public_path__ + "static/media/cashflow.a66bf63e5c0c4a3b684f7f543cfe1f35.svg";
export { ForwardRef as ReactComponent };